import { render, staticRenderFns } from "./LiftArea.vue?vue&type=template&id=0ed79e9c&scoped=true&"
import script from "./LiftArea.vue?vue&type=script&lang=js&"
export * from "./LiftArea.vue?vue&type=script&lang=js&"
import style0 from "./LiftArea.vue?vue&type=style&index=0&id=0ed79e9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed79e9c",
  null
  
)

export default component.exports